const CHUNK_SIZE = 1024 * 1024 * 10; // 10MB chunks


exports.readFileInChunks = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      const chunks = [];
      let offset = 0;
  
      const readNextChunk = () => {
        const chunk = file.slice(offset, offset + CHUNK_SIZE);
        reader.readAsDataURL(chunk);
      };
  
      reader.onload = (e) => {
        if (e.target.result) {
          // מוציא את ה-base64 מתוך ה-DataURL
          const base64String = e.target.result.split(',')[1];
          chunks.push(base64String);
          offset += CHUNK_SIZE;
  
          if (offset < file.size) {
            // עוד יש חלקים לקרוא
            readNextChunk();
          } else {
            // סיימנו לקרוא את כל הקובץ
            resolve({
              name: file.name,
              type: file.type,
              size: file.size,
              chunks: chunks,
              totalChunks: chunks.length
            });
          }
        }
      };
  
      reader.onerror = reject;
      readNextChunk();
    });
  };
  

exports.downloadFile = async (file, filename) => {
    try {
  
      // Create blob from base64 data
      const byteCharacters = atob(file);
      const byteNumbers = new Array(byteCharacters.length);
      
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray]);
  
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Get original filename from path
      link.setAttribute('download', filename);
      
      // Append to document, trigger click and cleanup
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      
    } catch(err) {
      throw err;
    }
  };